// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryItemSharedStyles from "@guestsupply/App/SharedStyles/categoryItemSharedStyles";
import { categoryListStyles } from "@guestsupply/Overrides/Widgets/Category/CategoryList";
import { css } from "styled-components";

categoryListStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
    `,
};

categoryListStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

categoryListStyles.container = {
    ...categoryItemSharedStyles.container,
};

categoryListStyles.categoryItem = {
    ...categoryItemSharedStyles.categoryItem,
};

categoryListStyles.innerContainer = {
    ...categoryItemSharedStyles.innerContainer,
};

categoryListStyles.categoryImageLink = {
    ...categoryItemSharedStyles.categoryImageLink,
};
categoryListStyles.categoryImage = {
    ...categoryItemSharedStyles.categoryImage,
};

categoryListStyles.subCategoryNameLink = {
    ...categoryItemSharedStyles.subCategoryNameLink,
};

categoryListStyles.viewMoreLinkItem = {
    ...categoryItemSharedStyles.viewMoreLinkItem,
};
categoryListStyles.viewMoreLink = {
    ...categoryItemSharedStyles.viewMoreLink,
};

categoryListStyles.categoryContainer = {
    ...categoryItemSharedStyles.categoryContainer,
};

categoryListStyles.categoryHeader = {
    ...categoryItemSharedStyles.categoryHeader,
};
